module.exports = __webpack_public_path__ + "static/basic-flow_2-7096e5587cab31d3462123d57ce9a4c6.png";